import React from "react";
import PropTypes from "prop-types";

const FenceIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#fence-icon-clip)">
        <path
          d="M2.66732 2L1.33398 3.33333V13.3333C1.33398 13.7333 1.60065 14 2.00065 14H3.33398C3.73398 14 4.00065 13.7333 4.00065 13.3333V3.33333L2.66732 2"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 5.33301H6.66667"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 12H6.66667"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99935 2L6.66602 3.33333V13.3333C6.66602 13.7333 6.93268 14 7.33268 14H8.66602C9.06602 14 9.33268 13.7333 9.33268 13.3333V3.33333L7.99935 2"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33398 5.33301H12.0007"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33398 12H12.0007"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 2L12 3.33333V13.3333C12 13.7333 12.2667 14 12.6667 14H14C14.4 14 14.6667 13.7333 14.6667 13.3333V3.33333L13.3333 2"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="fence-icon-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

FenceIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FenceIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default FenceIcon;
